import React, { useState } from "react";
import { Button, TextInput } from "flowbite-react";

function UpdateCredentials() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    const token = localStorage.getItem("token");

    if (!email && !password) {
      alert("Please provide at least one field to update (email or password).");
      return;
    }

    fetch("https://jewellery-mysql-backend.onrender.com/user/update", {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`, 
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }), 
    })
    .then((response) => {
      console.log(response)
      if (!response.ok) {
          return response.json().then((err) => {
              throw new Error(err.error );
          });
      }
      localStorage.removeItem('token'); 
    
      window.location.href = '/admin/login';
      return response.json();
  })
      .then((data) => {
        setMessage({
          type: "success",
          text: data.message ,
        });
        setEmail(""); 
        setPassword(""); 
      })
      .catch((error) => {
        setMessage({ type: "error", text: error.message });
      });
  };

  return (
    <div className="px-4 my-12 m-auto lg:w-[1140px]">
      <h2 className="font-bold text-3xl mb-6 text-center">Update Admin</h2>

      {message && (
        <div
          className={`mb-4 p-4 text-center ${
            message.type === "success" ? "text-green-700 bg-green-200" : "text-red-700 bg-red-200"
          }`}
        >
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit} className="flex flex-col gap-6">
        <div>
          <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900">
            Email 
          </label>
          <TextInput
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter new email"
            className="w-full rounded"
          />
        </div>

        <div>
          <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900">
            Password 
          </label>
          <TextInput
            type="password"
            id="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter new password"
            className="w-full rounded"
          />
        </div>

        <Button type="submit">Update</Button>
      </form>
    </div>
  );
}

export default UpdateCredentials;
